const backlog2027 = {
  id: "backlog-2027",
  titulo: "Backlog 2027",
  pathModulo: "/novas-vendas",
  icone: "TrendingUp",
  allowedRoles: [
    "admin",
    "financeiro",
    "diretor",
    "OPERACAO",
    "ASSISTENTEOPERACAO",
    "COMERCIAL",
    "GESTOR_ESTRATEGICO",
  ],
  descricao:
    "Cadastro e acompanhamento das vendas comerciais, com a divisão de cada contrato entre backlog de 2026 e de 2027. Mostra KPIs de Novas Vendas do ano corrente, Backlog de anos anteriores e o total Geral, além de um gráfico comparativo por cliente.",
  passoAPasso: [
    {
      titulo: "Entenda as três seções de KPIs",
      texto:
        "\"Novas Vendas\" soma apenas os contratos cujo Ano da Venda é o ano atual; \"Backlog (Anos Anteriores)\" soma os demais; \"Geral\" soma tudo. Cada seção mostra Valor Total, Backlog 2026, Backlog 2027 e o percentual de cada backlog sobre o valor total.",
    },
    {
      titulo: "Filtre por cliente, mês ou ano",
      texto:
        "Digite no campo Cliente (com sugestão automática dos nomes já cadastrados) e/ou selecione Mês e Ano. O filtro de Ano considera apenas contratos com valor de backlog naquele ano (2026 ou 2027), não o Ano da Venda.",
    },
    {
      titulo: "Analise o gráfico Backlog por Cliente",
      texto:
        "O gráfico de barras horizontais empilhadas mostra, por cliente, a divisão entre Backlog 2026 e Backlog 2027, já ordenado do maior para o menor valor de contrato.",
    },
    {
      titulo: "Cadastre uma nova venda",
      texto:
        "Clique em \"Adicionar Nova Venda\" e preencha Cliente, Mês Inserido (texto livre, ex.: \"Julho/2026\"), Ano da Venda, Backlog 2026 e Backlog 2027. O Valor Contrato é validado automaticamente: precisa ser igual à soma dos dois backlogs.",
    },
    {
      titulo: "Edite ou exclua uma venda",
      texto:
        "Clique em uma linha da tabela \"Detalhamento de Vendas\" para selecioná-la — os botões \"Editar Venda\" e \"Excluir Venda\" ficam habilitados assim que uma linha é selecionada.",
    },
  ],
  dicas: [
    "Se o formulário travar com o erro \"O Valor Contrato deve ser igual à soma dos backlogs\", confira se os dois campos de backlog (2026 e 2027) somam exatamente o valor do contrato — inclusive centavos.",
    "Use o filtro de Ano (2026 ou 2027) para focar apenas nos clientes que ainda têm saldo de backlog para aquele ano específico.",
    "O campo Mês Inserido é texto livre — mantenha o padrão \"Mês/Ano\" (ex.: \"Março/2026\") para que o filtro de Mês funcione corretamente.",
  ],
  faq: [
    {
      pergunta: "Qual a diferença entre \"Ano da Venda\" e o backlog de 2026/2027?",
      resposta:
        "\"Ano da Venda\" indica em qual ano a venda foi fechada/registrada (usado para separar Novas Vendas de Backlog). Os campos Backlog 2026 e Backlog 2027 indicam a que ano de faturamento aquele valor do contrato pertence — um mesmo contrato pode ter valor dividido entre os dois anos.",
    },
    {
      pergunta: "Por que não consigo salvar uma venda?",
      resposta:
        "O motivo mais comum é a soma dos backlogs (2026 + 2027) não bater com o Valor Contrato informado. Ajuste os valores até que a soma seja exatamente igual.",
    },
    {
      pergunta: "É possível cadastrar uma venda só para 2027, sem valor em 2026?",
      resposta:
        "Sim — basta deixar o campo Backlog 2026 como 0 e informar o valor total em Backlog 2027 (e vice-versa).",
    },
  ],
};

export default backlog2027;
